import React, { lazy, Suspense, useEffect, useState } from 'react';
import { FaPhoneAlt, FaAmbulance, FaMapMarkerAlt, FaStar } from 'react-icons/fa';
import SEO from '../components/SEO';
import StructuredData from '../components/StructuredData';
import './Home.css';

const HomeDeferredSections = lazy(() => import('./HomeDeferredSections'));

const Home = () => {
  const [showDeferredSections, setShowDeferredSections] = useState(false);

  useEffect(() => {
    let idleId;
    let timeoutId;

    if ('requestIdleCallback' in window) {
      idleId = window.requestIdleCallback(() => setShowDeferredSections(true));
    } else {
      timeoutId = window.setTimeout(() => setShowDeferredSections(true), 1);
    }

    return () => {
      if (idleId) {
        window.cancelIdleCallback(idleId);
      }
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    };
  }, []);

  return (
    <main className="home">
      <SEO
        title="Trusted Ambulance & Patient Transport Services"
        description="Shreeji Ambulance provides 24x7 emergency ambulance, ICU ambulance, and patient transport services across India from Ahmedabad. Trusted since 2003."
        keywords="ambulance service, patient transport, emergency ambulance, ICU ambulance, Ahmedabad ambulance, medical transport India, 24x7 ambulance, Shreeji Ambulance, ambulance service Ahmedabad, patient transfer service, ambulance service near me, Best ambulance service in Ahmedabad, Ambulance service in Ahmedabad"
        canonical="https://shreejiambulance.in/"
      />
      <StructuredData type="home" />

      <section className="hero">
        <div className="hero-background">
          <div className="hero-pattern"></div>
        </div>
        <div className="container">
          <div className="hero-content">
            <div className="trust-badge">Since 2003</div>
            <h1 className="hero-title">
              Trusted Ambulance & Patient Transport Services
            </h1>
            <p className="hero-subtitle">
              Providing reliable, safe, and compassionate medical transport across India.
              Your trust drives us forward, mile after mile.
            </p>
            <div className="hero-cta">
              <a href="tel:+919825957225" className="btn btn-emergency">
                <FaPhoneAlt /> Call Now
              </a>
              <a href="/contact" className="btn btn-secondary">
                Book Service
              </a>
            </div>
            <div className="hero-features">
              <div className="feature-item">
                <span className="feature-icon"><FaAmbulance /></span>
                <span>24x7 Available</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon"><FaMapMarkerAlt /></span>
                <span>All Over India Service from Ahmedabad</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon"><FaStar /></span>
                <span>Since 2003</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {showDeferredSections && (
        <Suspense fallback={null}>
          <HomeDeferredSections />
        </Suspense>
      )}
    </main>
  );
};

export default Home;
